import type { SORT_BY, SORT_ORDER } from '@/types';

export type ChurchListing = {
  type: CHURCH_TYPE;
  programs: Record<CHURCH_PROGRAM, boolean>;
  id: string;
  name: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zipCode: string;
  diocese?: {
    id?: string;
    name?: string;
  };
  clusterName?: string;
};

export type PhoneView = {
  prefix?: string;
  number?: string;
};

export type ChurchDioceseView = {
  id?: string;
  name?: string;
};

export type ClusterChurchView = {
  id?: string;
  name?: string;
  city?: string;
  zipCode?: string;
  productsEnabled?: boolean;
};

export type ClusterView = {
  id?: string;
  name?: string;
  mainChurchName?: string;
  mainChurchCity?: string;
  mainChurchState?: string;
  mainChurchZipCode?: string;
  churches: ClusterChurchView[];
};

export type Church = {
  id: string;
  programs: {
    [CHURCH_PROGRAM.MPA]: boolean;
    [CHURCH_PROGRAM.CAMINO]: boolean;
    [CHURCH_PROGRAM.MESSAGING]: boolean;
    // [CHURCH_PROGRAM.MIO]: boolean;
    // [CHURCH_PROGRAM.MINISTRY_SCHEDULER]: boolean;
    // [CHURCH_PROGRAM.ADORATION]: boolean;
  };
  fullName?: string;
  shortName?: string;
  addressLine1?: string;
  addressLine2?: string;
  country?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  latitude?: number | null;
  longitude?: number | null;
  website?: string;
  givingName?: string;
  phone?: string | PhoneView;
  timezone?: string;
  type?: CHURCH_TYPE;
  diocese?: ChurchDioceseView;
  bulletinId?: string;
  cluster?: ClusterView;
  keyword?: string;
  isClusterEditable: boolean;
  qbAccount?: string | null;
  discoverMassId?: string;
};

export type ChurchMultiSelectOption = {
  value: string;
  label: string;
};

export type GetChurchesParams = {
  term?: string;
  cursor?: string;
  limit?: number;
  sortBy?: SORT_BY;
  sortOrder?: SORT_ORDER;
  programs?: CHURCH_PROGRAM[];
};

export type SearchChurchesParams = {
  term?: string;
  cluster?: boolean;
  diocese?: boolean;
};

export type ChurchesResponse = {
  items: ChurchListing[];
  limit: number;
  total: number;
};

export enum CHURCH_TYPE {
  DIOCESE = 'diocese',
  PARISH = 'parish',
  CLUSTER = 'cluster',
}

export enum CHURCH_PROGRAM {
  MPA = 'mpa',
  CAMINO = 'camino',
  MESSAGING = 'messaging',
  MIO = 'mio',
  MINISTRY_SCHEDULER = 'ministry_scheduler',
  ADORATION = 'adoration',
  FACILITY_SCHED = 'facility_sched',
  FORMS = 'forms',
  MESSAGES = 'messages',
}

export const PROGRAM_LABELS: Record<CHURCH_PROGRAM, string> = {
  [CHURCH_PROGRAM.MPA]: 'MyParish (MPA)',
  [CHURCH_PROGRAM.CAMINO]: 'Camino',
  [CHURCH_PROGRAM.MESSAGING]: 'Messaging',
  [CHURCH_PROGRAM.MIO]: 'MIO',
  [CHURCH_PROGRAM.MINISTRY_SCHEDULER]: 'Ministry Scheduler',
  [CHURCH_PROGRAM.ADORATION]: 'Adoration',
  [CHURCH_PROGRAM.FACILITY_SCHED]: 'Facility Sched',
  [CHURCH_PROGRAM.FORMS]: 'Forms',
  [CHURCH_PROGRAM.MESSAGES]: 'Messages',
};

export type SubChurchProducts = Record<string, boolean>;

export type Cluster = {
  id?: string;
  name: string;
  churches: string[];
  subChurchProducts?: SubChurchProducts;
};

export enum ORGANIZATION_MODAL_MODE {
  CREATE = 'create',
  EDIT = 'edit',
}

export type ChurchCreateRequest = {
  fullName: string;
  shortName: string;
  country: string;
  city: string;
  state: string;
  zipCode: string;
  addressLine1: string;
  type: string;
  keyword: string;
  timezone: string;
  phone: string;
  addressLine2?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  dioceseId?: string | null;
  website?: string | null;
  givingName?: string | null;
  bulletinId?: string | null;
  discoverMassId?: string | null;
  qbAccount?: string | null;
  cluster?: Cluster | null;
};

export type ChurchUpdateRequest = {
  fullName: string;
  shortName: string;
  country: string;
  city: string;
  state: string;
  zipCode: string;
  addressLine1: string;
  type: string;
  timezone: string;
  addressLine2?: string;
  latitude?: number | null;
  longitude?: number | null;
  dioceseId?: string;
  phone: string | null;
  website?: string;
  givingName?: string;
  bulletinId?: string;
  cluster?: Cluster | null;
  keyword?: string;
  qbAccount?: string | null;
  discoverMassId?: string;
};
